<template>
  <div class="step2-container">
    <div class="title">手机号验证</div>
    <div class="des">
      请输入手机号{{
        userInfo.mobileFuzzy
      }}收到的6位验证码，有效期三分钟。<br />如验证码失效，请尝试重新获取验证码。
    </div>
    <div class="form">
			<el-input
				v-model="formData.verifyCode"
				placeholder="请输入短信验证码"
				size="large"
				class="input-item"
				:class="[!!formData.errorMsg ? 'error' : '']"
				clearable
				@input="handleChange"
			/>
			<div v-show="formData.errorMsg" class="error-tip">
				{{ formData.errorMsg }}
			</div>
			
			<div class="identifying">
				<TimeCount :before-count="sendSms"/>
			</div>

			<el-button type="primary"  size="large" style="width: 400px" @click="onSubmit">
				下一步
			</el-button>
    </div>
    <div class="tips">
      <span v-if="!userInfo.isAdmin">
				手机号不再使用或无法收到验证码？请联系企业管理员为您重置手机号。
			</span>
      <span v-else>手机号不再使用或无法收到验证码？请联系实施或销售处理。</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive } from 'vue'

import { catchError } from '@/utils'
import { UserInfoForRetrievePassword } from 'types/api'
import { sendSmsForRetrievePass, verifySmsCodeForRetrievePass } from '@/api/retrieve'

import TimeCount from "@/components/TimeCount.vue"
import * as popups from "@/components/Popup"

const props = defineProps<{
	userInfo: UserInfoForRetrievePassword,

  next: (authKey: string) => void;
}>()

const formData = reactive({
  verifyCode: '',
  authKey: '',
  errorMsg: '',
})
// 倒计时
const countdown = ref(0)

const handleChange = (val) => {
  if (val) {
    formData.verifyCode = formData.verifyCode.replace(/\D/g, '')
    if (formData.verifyCode.length > 6) {
      formData.verifyCode = formData.verifyCode.slice(0, 6)
    }
  }
}

const validateCode = (): boolean => {
  formData.errorMsg = ""
  if (!formData.verifyCode) {
    formData.errorMsg = '验证码不能为空'
    return false
  }
  if(!formData.authKey){
    formData.errorMsg = '请先点击获取验证码'
    return false
  }
  return true
}


/**
 * 获得短信验证码
 */
 const sendSms = async () => {
	const captchaId = await popups.showCaptchaDialog();

  const { response, error } = await catchError(
    sendSmsForRetrievePass({
			tenantId: props.userInfo.tenantId,
			employeeId: props.userInfo.employeeId,
			captchaId: captchaId
    })
  )

  if (error) {
    return;
  }

	if (response?.code) {
		formData.errorMsg = response!.message
		return
	}

	// 验证key
	formData.authKey = response!.data
}


/**
 * 提交
 */
const onSubmit = async () => {
  if (!validateCode()) return

  const { response, error } = await catchError(
    verifySmsCodeForRetrievePass(
      {
        authKey: formData.authKey,
        verifyCode: formData.verifyCode,
      }
    )
  )
  if (error) {
    return;
  }
	
	if (response?.code) {
    formData.errorMsg = response!.message
    return
  }

  props.next(formData.authKey);
}


</script>
<style lang="scss" scoped>
.step2-container {
  text-align: center;
  .title {
    font-size: 24px;
    font-weight: 600;
  }

  .des {
    font-size: 14px;
    color: #999;
    margin-top: 15px;
  }

  .form {
		display: flex;
		flex-direction: column;
    padding-top: 30px;
		position: relative;

		& > * {
			width: 400px;
			height: 32px;
			--el-input-height: 30px;
			place-self: center;
		}

		
		.error-tip {
			position: relative;
			font-size: 12px;
			color: red;
			line-height: 28px;
			text-align: left;
		}

    .form-inline {
      @media screen and (orientation: portrait) {
        width: 300px;
      }
      .input-item {
        width: 400px;
      }
    }

    .error {
      :deep(.el-input__wrapper) {
        box-shadow: 0 0 0 1px var(--el-color-danger) inset;
      }
    }

    .identifying {
      text-align: center;
      width: 100%;
			margin-bottom: 12px;

      .identifying-countdown {
        color: #c0c4cc;
        margin-top: auto;
        margin-bottom: auto;
        margin-left: 0px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }

      .identifying-code {
        margin-right: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #3d8eff;
        line-height: 20px;
        cursor: pointer;
        font-weight: 500;
      }
    }
  }


  .tips {
    font-size: 14px;
    color: #999;
		margin-top: 12px;
  }
}
</style>
